import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  standalone: false,
  selector: 'app-evaluation',
  templateUrl: './evaluation.component.html',
  styleUrls: ['./evaluation.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      state('*', style({ opacity: 1 })),
      transition('void => *', animate('300ms ease-in')),
      transition('* => void', animate('300ms ease-out'))
    ]),
    trigger('slideIn', [
      state('void', style({ transform: 'translateY(-20px)', opacity: 0 })),
      state('*', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('void => *', animate('400ms ease-out')),
      transition('* => void', animate('400ms ease-in'))
    ]),
    trigger('starPulse', [
      state('idle', style({ transform: 'scale(1)' })),
      state('pulsing', style({ transform: 'scale(1.2)', color: 'gold' })),
      transition('idle <=> pulsing', animate('200ms ease-in-out'))
    ]),
    trigger('checkPulse', [
      state('unchecked', style({ transform: 'scale(1)' })),
      state('checked', style({ transform: 'scale(1.1)', color: '#28a745' })),
      transition('unchecked <=> checked', animate('300ms ease-in-out'))
    ]),
    trigger('fadeIn', [
      state('hidden', style({ opacity: 0, height: 0 })),
      state('visible', style({ opacity: 1, height: '*' })),
      transition('hidden => visible', animate('400ms ease-in')),
      transition('visible => hidden', animate('400ms ease-out'))
    ]),
    trigger('confettiAnimation', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      transition('inactive => active', [
        animate('500ms', style({ opacity: 1 })),
        animate('2000ms', style({ opacity: 0 }))
      ]),
      transition('active => inactive', animate('500ms'))
    ])
  ]
})
export class EvaluationComponent {
  @Output() evaluationSubmitted = new EventEmitter<void>();
  evaluationForm: FormGroup;
  rating: number = 0;
  tempRating: number = 0;
  isVisible = true;
  isSubmitted = false;
  suggestionsVisible = false;

  constructor(private fb: FormBuilder) {
    this.evaluationForm = this.fb.group({
      easeOfUse: ['', Validators.required],
      easeComment: [''],
      favoriteFeature: [''],
      suggestions: ['']
    });
  }

  hoverRating(star: number) {
    this.tempRating = star;
  }

  resetHover() {
    this.tempRating = 0;
  }

  setRating(star: number) {
    this.rating = star;
    this.tempRating = star;
  }

  submitEvaluation() {
    if (this.rating === 0) {
      alert('Veuillez sélectionner une note !');
      return;
    }
    if (this.evaluationForm.invalid) {
      alert('Veuillez indiquer si l’application est facile à utiliser !');
      return;
    }
    const formData = { rating: this.rating, ...this.evaluationForm.value };
    console.log('Évaluation soumise : ', formData);
    this.isSubmitted = true;
    setTimeout(() => {
      this.isSubmitted = false;
      this.evaluationSubmitted.emit();
      this.isVisible = false;
    }, 2500);
  }

  closeModal() {
    this.isVisible = false;
    this.evaluationSubmitted.emit();
  }

  animationHandler(event: any) {
    if (event.phaseName === 'start') {
      console.log('Animation started:', event.triggerName);
    } else if (event.phaseName === 'done') {
      console.log('Animation done:', event.triggerName);
    }
  }

  animationStarted() {
    console.log('Animation started');
  }

  animationDone() {
    console.log('Animation done');
  }
}